module.exports = __webpack_public_path__ + "media/type.576c8cb2.mp3";